import React, { Component } from "react";
import styles from "../Percentage/Percentage.local.scss";
import { IconContext } from "react-icons";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { getTimeByDurationFormat } from "Utils";

class Variance extends Component {
  render() {
    const { variance } = this.props;
    if (!variance || variance === 0) {
      return <span className={styles.percentage__na}>N/A</span>;
    }
    if (variance > 0) {
      return (
        <span className={styles.percentage__positive}>
          {/*&nbsp;*/}
          <span className="">
            <IconContext.Provider
              value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
            >
              <TiArrowSortedUp />
            </IconContext.Provider>
          </span>
          <span>{getTimeByDurationFormat(variance)}</span>
        </span>
      );
    } else if (variance < 0) {
      return (
        <span className={styles.percentage__negative}>
          {/*&nbsp;*/}
          <span className="">
            <IconContext.Provider
              value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
            >
              <TiArrowSortedDown />
            </IconContext.Provider>
          </span>
          {getTimeByDurationFormat(variance)}
        </span>
      );
    }
  }
}

export default Variance;



// WEBPACK FOOTER //
// ./src/components/Common/Variance/Variance.js